import { useFetchUser, useFetchUserAnalyticReportAccess } from '@jooxter/core';
import { SCREEN_SIZE } from '@jooxter/utils';
import { useIsSmallScreen } from '@jooxter/ui';
import { UIPermissionsLayer } from '../core/UIPermissions.layer';

export const usePermissions = () => {
  const { user, isLoading: isUserLoading } = useFetchUser();
  const { userAnalyticAccess, isLoading: isAnalyticsAccessLoading } = useFetchUserAnalyticReportAccess(user?.id);
  const isMobile = useIsSmallScreen(SCREEN_SIZE.MD);
  const uIPermissions = UIPermissionsLayer.getInstance(isMobile, user, userAnalyticAccess);
  const permissions = uIPermissions.getPermissions();
  const isLoading = isUserLoading || isAnalyticsAccessLoading;

  // Split for the app shell: it only waits for the user; analytics access only gates the analytics pages.
  return { permissions, isLoading, isUserLoading, isAnalyticsLoading: isAnalyticsAccessLoading };
};
